function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.729h30v18.541H0V5.729Z",
    style: {
      fill: "#006a4e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.438h30v3.708H0v-3.708Z",
    style: {
      fill: "#ffce00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5.729h11.125v12.979H0V5.729Z",
    style: {
      fill: "#d21034"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,16.854h30v3.708H0v-3.708Z",
    style: {
      fill: "#ffce00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M5.562,7.769l-1.089,3.35,1.763.573",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M5.562,7.769l1.089,3.35-1.763.573",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M8.913,10.203h-3.523v1.854",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M8.913,10.203l-2.85,2.071-1.09-1.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M3.492,14.142l2.85-2.071-1.09-1.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5",
    "data-name": "a",
    d: "M3.492,14.142l1.089-3.35,1.763.573",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a6",
    "data-name": "a",
    d: "M7.633,14.142l-1.089-3.35-1.763.573",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a7",
    "data-name": "a",
    d: "M7.633,14.142l-2.85-2.071,1.09-1.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8",
    "data-name": "a",
    d: "M2.212,10.203l2.85,2.071,1.09-1.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9",
    "data-name": "a",
    d: "M2.212,10.203h3.523v1.854",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/TG.8c0e8c7a8d25b360e2415f159b5113ab.svg";
export { ForwardRef as ReactComponent };